import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { SpinnerService } from 'shared-components';
import { EtiquetadoService } from '../../../../services/etiquetado.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-etq-rtq-new-edit',
    templateUrl: './new-edit.component.html'
})
export class EtqRtqNewEditComponent implements OnInit {

    public newEditForm: UntypedFormGroup;
    public showError = false;
    public deleteModal = false;
    private _editable: boolean;

    private etqrtqId: any;

    public toCloseSpinner = 0;

    public denominaciones;
    public reetiquetadores;

    public reetiquetador;

    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledReetiquetadores: Subject<boolean> = new Subject();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                this.disabledDenominaciones.next(false);
                this.disabledReetiquetadores.next(false);
            }
        }
    }
    @Input() reetiquetadorEtq?;
    @Input() etiquetadorId: number;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() close = new EventEmitter<boolean>();


    constructor(
        private _fb: UntypedFormBuilder,
        private _etiquetadoService: EtiquetadoService,
        private readonly _dataProvider: DataProvider,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            reetiquetador: [{ value: '', disabled: true }, Validators.required],
        });

        this.getReetiquetadores();
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public getReetiquetadores() {
        return new Promise((resolve, reject) => {
            let filters = {
                esReetiquetador: true
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._etiquetadoService.getEtiquetadores(filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.reetiquetadores = resp.lista;
                    this.newEditForm.get('reetiquetador').enable();
                    this.disabledReetiquetadores.next(false);
                    if (this.reetiquetadorEtq) {
                        this.disabledReetiquetadores.next(true);
                        this.newEditForm.get('reetiquetador').patchValue(
                            this.reetiquetadores.find(reetiquetador => reetiquetador.id === this.reetiquetadorEtq.reetiquetadorId));
                    }
                    setTimeout(resolve, 1);
                }
            });
        });
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid) {
            let reetiquetadorEtiquetador = {
                etiquetadorId: this.etiquetadorId,
                reetiquetadorId: this.newEditForm.get('reetiquetador').value.id
            };
            this._spinnerService.showSpinner();
            this._etiquetadoService.asociarEtqRtq(reetiquetadorEtiquetador).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(() => {
                this.refresh.emit(true);
                this.newEditForm.disable();
                this.disabledDenominaciones.next(true);
                this.disabledReetiquetadores.next(true);
                this.pushMessage.emit('global.success.itemCreated');
            },
                (error) => {
                    this.showError = true;
                    if (error.status === 420) {
                        switch (error.error.ApiErrorCode) {
                            case 6070:
                                this.pushMessage.emit('ApiErrors.etiquetadorYaAsociado');
                                break;
                            default:
                                this.pushMessage.emit('global.error.noResponse');
                                break;
                        }
                    } else {
                        this.pushMessage.emit('global.error.noResponse');
                    }
                });
        }
    }

    public closeModal() {
        this.deleteModal = false;
        this.etqrtqId = null;
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }

    public cancel() {
        this.close.emit(false);
    }

    public askDelete() {
        this.deleteModal = true;
        this.etqrtqId = this.reetiquetadorEtq.reetiquetadorId;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.deleteEtqRtq(this.etiquetadorId, this.etqrtqId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.closeModal();
            this.refresh.emit(true);
            this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }
}
